(function () {
  'use strict';
  var observer;
  function setup() {
    if (observer) observer.disconnect();
    var shortcut = document.querySelector('[data-tempo-quick-enquiry]');
    var form = document.querySelector('[data-tempo-photo-enquiry]');
    var target = form && (form.closest('.tempo-enquiry-panel') || form);
    if (target) {
      if (!target.id) target.id = 'tempo-quick-enquiry-form';
      document.querySelectorAll('[data-tempo-enquire]').forEach(function (link) {
        link.setAttribute('href', '#' + target.id);
      });
      if (shortcut && 'IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          shortcut.hidden = entries[0].isIntersecting;
        }, {rootMargin: '-120px 0px 0px 0px', threshold: 0});
        observer.observe(target);
      }
      if (location.hash === '#tempo-quick-enquiry-form') target.scrollIntoView();
    } else if (shortcut) shortcut.hidden = false;
  }
  document.addEventListener('click', function (event) {
    var link = event.target.closest && event.target.closest('[data-tempo-enquire]');
    if (!link || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var href = link.getAttribute('href');
    if (!href || href.charAt(0) !== '#') return;
    var target = document.getElementById(href.slice(1));
    if (!target) return;
    event.preventDefault();
    target.setAttribute('tabindex', '-1');
    target.focus({preventScroll: true});
    target.scrollIntoView({behavior: 'auto', block: 'start'});
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup);
  else setup();
  document.addEventListener('shopify:section:load', setup);
  document.addEventListener('page:load', setup);
}());
